/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const TIMER_VAR_NAME = feature.getSettingValue('TIMER_NAME');
    const TIMER_NAME = `timer_${feature.getSettingValue('TIMER_NAME')}`;

    blocks.push({
        location: 'VARIABLE_DECLARATIONS',
        blockType: BlockType.CODE,
        // template: `dim ${VARNAME} as ${DATATYPE}=${defaultValue}`,
        template: `struct k_timer ${TIMER_NAME};`,
    });

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.CODE,
        template: `
void ${TIMER_NAME}_completed_handler(struct k_timer *timer_id)
{
    /****${TIMER_NAME}_completed_handler****/
}`,
    });

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
k_timer_init(&${TIMER_NAME}, ${TIMER_NAME}_completed_handler, NULL);
`,
    });

    return blocks;
};
